import Icon from '@passkeys/ui/icon';

import { collapseWidget } from '@/ui/utils/widget-size';

function ToggleButton() {
  return (
    <button
      className="inline-flex items-center justify-center text-black transition-opacity hover:opacity-50 theme-dark:text-neutral-200"
      onClick={() => collapseWidget()}
      type="button"
      data-testid="toggle-button"
    >
      <Icon name="caret-up-right-caret-down-left-to-center" size={32} />
    </button>
  );
}

export default ToggleButton;
